import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../user.css';
import { Image } from '@/components/Elements';
import business from '@/assets/business.jpeg';
// import { useHousingListing } from '@/api/housing/getHousingList';
import { Housing } from '@/types';
import { changeFav } from '@/api/housing/changeFav';
import propertyType from '@/constants/propertyType';
import { Modal } from 'react-responsive-modal';
import { Button } from '@/components/Elements/Button';
import { useNotificationStore } from '@/stores/notifications';
import { deletePropertyItem } from '@/api/deletePropertyItem';

import { changeAllFav } from '@/api/changeAllFav';
import { useAuth } from '@/lib/auth';
import { formatPrice, trimThirty } from '@/utils/format';
import storage from '@/utils/storage';
import i18next from 'i18next';
import plus from '@/assets/plus.png';
import FileViewer from '@/components/Viewer/FileViewer';
import { upperFirst } from 'lodash';
import { FeatureAdd } from './FeatureAddDialog';

const HousingRent = ({
  item,
  headData,
  editIcon,
  deleteIcon,
  heartIcon,
  heartFavIcon,
  setHeartClicked,
  setDeleteClicked,
  has_subscription,
}: {
  deleteIcon: boolean;
  item: Housing;
  headData: boolean;
  editIcon: boolean;
  heartFavIcon: boolean;
  heartIcon: boolean;
  setHeartClicked: any;
  setDeleteClicked: any;
  has_subscription: boolean;
}) => {
  // const { refetch } = useHousingListing({ page: '1' });
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`/housing-detail/${item.id}?type=HouseRent`);
  };
  const { user } = useAuth();

  const [open, setOpen] = useState(false);
  // const onOpenModal = () => setOpen(true);
  const localSymbol = storage.getSymbol();
  const localCurrency = storage.getAmount();
  console.log("localCurrency",localCurrency)
  const [showFeatureAdd, setShowFeatureAdd] = useState(false);

  const onOpenModals = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setOpen(true);
  };
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const typeVal = 'HouseRent';
  const deleleItems = async (id: string, types: string) => {
    try {
      setButtonLoading(true);
      await deletePropertyItem(id, types);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Item deleted successfully!',
      });
    } finally {
      setDeleteClicked(true);
      setOpen(false);
      setButtonLoading(false);
    }
  };

  const [favIcon, setFavIcon] = useState<boolean>(!!item.is_favourite);
  const deleleItemsSelect = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    deleleItems(item.id, typeVal);
  };
  const onCloseModal = () => setOpen(false);

  const changeStatusAction = async (id: string, accept: boolean) => {
    try {
      if (user) {
        await changeFav(id, accept);
        setHeartClicked(true);
      } else {
        useNotificationStore.getState().addNotification({
          title: 'Warning',
          type: 'info',
          message: 'Please Login first!',
        });
        navigate('/auth/login');
      }
    } finally {
    }
  };
  const changeUnfavStatusAction = async (id: string, type: string) => {
    try {
      const data: any = await changeAllFav(id, type);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: upperFirst(data?.message),
      });
    } finally {
      setHeartClicked(true);
    }
  };
  const handleUnfavourite = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeUnfavStatusAction(item.id, item.type);
    // refetch();
  };
  const handleClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setFavIcon((val) => !val);
    changeStatusAction(item.id, false);
  };
  const handleClick2 = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeStatusAction(item.id, true);
    setFavIcon((val) => !val);
  };
  const handleEdit = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    navigate(`/user/house-wanted-for-rent?id=${item.id}&type=HouseRent`);
  };

  const [photo, setPhoto] = useState<any>();

  const [pics, setPics] = useState<any>();
  const [img1, setImg1] = useState();

  // useEffect(() => {
  //   try {
  //     const evaluatedData = eval(item?.image);
  //     setPics(evaluatedData);

  //     if (item?.image && item?.image.length > 0 && pics) {
  //       setPhoto(pics[0]?.image);
  //     }
  //   } catch (error) {
  //     console.error('Error evaluating image_data:', error);
  //   }
  // }, [item?.image, pics]);
console.log("item?.image_data",item?.image_data)
  useEffect(() => {
    if (item?.image) {
      console.log("item?.image_data",item.image_data)
      const parsed_data = item?.image;
      setImg1(parsed_data[0]);
    }
  }, [item?.image_data]);

  return (
    <>
      <div className="col-12 col-md-6 col-lg-3 home-prop-col">
        <button className="housingButton" onClick={handleNavigate}>
          <div className="item-box deals-page p-2 position-relative">
            {headData == true ? (
              <>
                <div className="head-functions">
                  <span className="status">{i18next.t('Find Tenants')}</span>
                  <div className="d-flex icons">
                    {editIcon == true ? (
                      <span>
                        <button onClick={handleEdit}>
                          <i className="fa-solid fa-pen" />
                        </button>
                      </span>
                    ) : null}
                    {deleteIcon == true ? (
                      <span>
                        <button onClick={onOpenModals}>
                          <i className="fa-solid fa-trash" />
                        </button>
                      </span>
                    ) : null}
                    {heartIcon == true ? (
                      <div className=" fav-lists">
                        {favIcon ? (
                          <button onClick={handleClick}>
                            <i className="fa-solid fa-heart"></i>
                          </button>
                        ) : (
                          <button onClick={handleClick2}>
                            <i className="fa-regular fa-heart"></i>
                          </button>
                        )}
                      </div>
                    ) : null}
                    {heartFavIcon == true ? (
                      <div className=" fav-lists">
                        <button onClick={handleUnfavourite}>
                          <i className="fa-solid fa-heart"></i>
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="head-functions3">
                  <span
                    className={`status ${
                      item?.status == 'Approved'
                        ? 'approved'
                        : item?.status == 'Pending'
                        ? 'pending'
                        : 'disapprove'
                    }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item?.status}
                  </span>

                  {(has_subscription && item?.status === 'Approved') || item?.is_ad_featured ? (
                    <span className="feature" onClick={(e) => e.stopPropagation()}>
                      Featured
                    </span>
                  ) : (
                    !has_subscription &&
                    !item?.is_ad_featured &&
                    item?.status === 'Approved' && (
                      <span
                        className="status"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowFeatureAdd(true);
                        }}
                      >
                        Add Feature
                      </span>
                    )
                  )}
                </div>
              </>
            ) : (
              <div className="head-functions2 ">
                {item?.is_favourite == true ? (
                  <button onClick={handleClick}>
                    <i className="fa-solid fa-heart"></i>
                  </button>
                ) : (
                  <button onClick={handleClick2}>
                    <i className="fa-regular fa-heart"></i>
                  </button>
                )}
              </div>
            )}

            {/* <Image imagefallback={business} className="itemImage" alt="banner" src={item.image} /> */}

            {item?.image || item?.image_data ? (
              <>
                {item?.image?.length == 0 ? (
                  <FileViewer file={plus ?? ''}></FileViewer>
                ) : (
                  <div className="res-slider-icon">
                    <Image
                      // imagefallback={eval(item?.image_data)[0]?.image}
                      className="itemImage"
                      alt="banner"
                      src={img1 ?? ''}
                    />
                  </div>
                )}
              </>
            ) : null}

            <h6 className="mt-3 text-dark">{item.fullname}</h6>
            <p className="text-sm makeLeft">
              <i className="fa-solid fa-map-location-dot"></i>
              {trimThirty(item.location)}
            </p>
            <div className="tab">
              <p>
                {i18next.t('Max Monthly Rent')} {localSymbol}
              </p>
              <p>
                {localSymbol} {formatPrice(item.max_month_price * localCurrency)}
                {/* {localSymbol} {formatPrice(item.max_month_price)} */}
              </p>
            </div>
            <div className="tab">
              <p>{i18next.t('No. of people')}</p>

              {/* <p>{propertyType[item?.number_of_people]}</p> */}
              <p>{item?.number_of_people}</p>
            </div>
            <div className="tab">
              <p>{i18next.t('Rental Period')}</p>
              <p>{item?.rental_period}</p>
            </div>

            {/* <div className="tab">
              <p>{i18next.t('Pet Allowed')}</p>
              <p>{item?.pet === 'true' ? 'Yes' : 'No'}</p>
            </div> */}

            {/* <div className="tab">
              {
                item?.pet === 'no'
                  ? `${i18next.t('No pet is allowed')}`

                 : `${item?.no_of_resident ?? 0} ${i18next.t('person with a pet')}`
              }
              //  <p>Number Of Residents</p>
              // <p>{item.no_of_resident}cccccc</p>
            </div> */}
          </div>
        </button>
        <Modal open={open} onClose={onCloseModal} center>
          <section className="model-datas text-center">
            <h3>{i18next.t('Are you sure you want to delete this item ?')}</h3>
          </section>
          <p className="btn-lines delete-bots  d-flex justify-content-center">
            <Button isLoading={buttonLoading} onClick={deleleItemsSelect}>
              {i18next.t('Yes')}
            </Button>
            <Button onClick={onCloseModal}>{i18next.t('No')}</Button>
          </p>
        </Modal>
      </div>
      <FeatureAdd
        propType="house_for_rent"
        propId={item.id}
        show={showFeatureAdd}
        setShow={setShowFeatureAdd}
      />
    </>
  );
};

export default HousingRent;
